import React, { useEffect, useState } from "react";
import "./TaskSettings.scss";
import { useGlobalSettings } from "../../../context/GlobalSettingsContext";
import {
  updateTaskSettings,
  getAllGlobalSettingsData,
} from "../../../services/api/GlobalSettingsApi";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../context/ToastContext";
import JusticeLoader from "../../../components/JusticeLoader/JusticeLoader";

const TaskSettings = () => {
  const [fetchingData, setFetchingData] = useState(true);
  const { globalSettings, setGlobalSettings } = useGlobalSettings();
  const [settings, setSettings] = useState({
    notifyAdmin: false
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();

  useEffect(() => {
    const fetchTaskSettings = async () => {
      try {
        setFetchingData(true);
        const response = await getAllGlobalSettingsData();

        if (response?.data?.result?.[0]?.taskSettings) {
          const taskSettings = response.data.result[0].taskSettings;
          setSettings({
            notifyAdmin: taskSettings.notifyAdmin || false
          });

          // Update global settings if not already set
          if (!globalSettings) {
            setGlobalSettings(response.data);
          }
        } else {
          // Set default values if no data exists
          setSettings({ notifyAdmin: false });
        }
      } catch (error) {
        console.error("Error fetching task settings:", error);
        showToast("Failed to fetch task settings", "error");
        // Set defaults on error
        setSettings({ notifyAdmin: false });
      } finally {
        setFetchingData(false);
      }
    };

    fetchTaskSettings();
  }, [globalSettings, setGlobalSettings]);

  useEffect(() => {
    if (globalSettings?.result?.[0]?.taskSettings) {
      const taskSettings = globalSettings.result[0].taskSettings;
      setSettings({
        notifyAdmin: taskSettings.notifyAdmin || false
      });
    }
  }, [globalSettings]);

  if (fetchingData) {
  return (
    <section className="task-sett-section">
      <h3 className="task-sett-title">Task Settings</h3>
      <JusticeLoader message="Loading task settings..." type="gavel" />
    </section>
  );
}

  const handleToggle = (field) => {
    setSettings((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await updateTaskSettings({ notifyAdmin: settings.notifyAdmin });

      const updated = await getAllGlobalSettingsData();
      setGlobalSettings(updated.data);
      localStorage.setItem("globalSettings", JSON.stringify(updated.data));

      showToast("Tasks updated successfully.", "success");
      setTimeout(() => {
        navigate("/home/displayboard");
      }, 300);
    } catch (err) {
      console.error(err);
      showToast("Something went wrong to update Tasks!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="task-sett-section">
        <h3 className="task-sett-title">Task Settings</h3>
        <div className="settings-container">
          <div className="settings-card">
            <h4 className="card-title">Notification Settings</h4>
            
            <div className="toggle-row">
              <label>Notify Admin</label>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={settings.notifyAdmin || false}
                  onChange={() => handleToggle("notifyAdmin")}
                  id="notifyAdmin"
                />
                <label htmlFor="notifyAdmin" className="toggle-slider"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button
            className="cancel-btn"
            onClick={() => navigate("/home/displayboard")}
          >
            Cancel
          </button>
          <button
            className="save-btn"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Task Settings"}
          </button>
        </div>
      </section>
    </>
  );
};

export default TaskSettings;